/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/TriPeaksLogic/ChallengeAuthorities/AchieveScoreDailyTripeaksAuthority',[
    'SolitaireShared/TriPeaksLogic/TriPeaksAuthority',
    'SolitaireShared/TriPeaksLogic/IDailyTripeaksAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/IAchieveScoreDailyAuthority',
    'SolitaireShared/CardLogic/ChallengeConstants'
], function (TriPeaksAuthority, IDailyTriPeaksAuthority, IDailyAuthority, IAchieveScoreDailyAuthority, ChallengeConstants) {
    "use strict";

    var AchieveScoreDailyTriPeaksAuthority = function (param) {
        this.initAchieveScoreDailyTriPeaksAuthority(param);
    };

    AchieveScoreDailyTriPeaksAuthority.constructor = AchieveScoreDailyTriPeaksAuthority;
    AchieveScoreDailyTriPeaksAuthority.prototype = Object.create(IDailyTriPeaksAuthority.prototype);
    IAchieveScoreDailyAuthority.call(AchieveScoreDailyTriPeaksAuthority.prototype);

    AchieveScoreDailyTriPeaksAuthority.prototype.initAchieveScoreDailyTriPeaksAuthority = function (param) {
        IDailyTriPeaksAuthority.call(this);

        if (param != null && param[ChallengeConstants.KeyScoreRequired])
            this.ScoreRequired = parseInt(param[ChallengeConstants.KeyScoreRequired]);
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.AchieveScore;
    };

    AchieveScoreDailyTriPeaksAuthority.prototype.IsGameWon = function () {
        if (this.CardSupply.WaitingForAnimation)
        {
            // We don't win unless the card animation is finished.
            return false;
        }

        if(this.CardSupply.IsWaitingForAds)
        {
            return false;
        }
//#if !GAMESTATETOOL
        if(!this.CardSupply.IsGamePageLoaded)
        {
            return false;
        }
//#endif
        if (this.CheckWin() && this.CardSupply.Score < this.ScoreRequired)
        {
            this.Deal();
        }
        return this.CardSupply.Score >= this.ScoreRequired;
    };

    return AchieveScoreDailyTriPeaksAuthority;

});
